import { Link, Outlet } from 'react-router-dom'

export function AuthShell() {
  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col">
      <header className="border-b bg-white">
        <div className="mx-auto max-w-6xl px-4 h-14 flex items-center">
          <Link to="/" className="font-semibold text-neutral-900">Iznir</Link>
        </div>
      </header>
      <main className="flex-1 flex items-start justify-center p-6">
        <Outlet />
      </main>
    </div>
  )
}
